import * as Yup from "yup";
import { FIELD_REQUIRED, MDP_CHARACTERS, MDP_MAX, MDP_MIN, MDP_MUST_MATCH } from "../../../common/constants/validationErrors";

const ForgotPasswordValidationSchemas = [
    Yup.object().shape({
        email: Yup.string().trim().email("Invalid email format").required(FIELD_REQUIRED),
    }),
    Yup.object().shape({
        code: Yup.string().trim().length(6, "Code must be exactly 6 digits").required(FIELD_REQUIRED),
    }),
    Yup.object().shape({
        newPassword: Yup.string()
            .matches(
              /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).*$/,
              MDP_CHARACTERS
            )
            .min(12, MDP_MIN)
            .max(25, MDP_MAX)
            .required(FIELD_REQUIRED),
        confirmPassword: Yup.string()
            .trim()
            .oneOf([Yup.ref("newPassword")], MDP_MUST_MATCH)
            .required(FIELD_REQUIRED),
    }),
];

export default ForgotPasswordValidationSchemas;
